export default __webpack_public_path__ + "static/media/logo-main-wht.dfadb149.png";